import { DELETE_SELECTED_DEVICE } from './';

export default function deleteSelectedDevice(reduxId) {
  return { type: DELETE_SELECTED_DEVICE, reduxId };
}
